<div class="conn-card">
    <app-report-top-filter-bar *ngIf="1==1" [paraReportName]="'credit-card-summary-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)" (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()" (exportPdfFn)="exportPdf()" (exportCsvFn)="dt.exportCSV()">
    </app-report-top-filter-bar>
    <br />
    <div *ngFor="let data of dataList; let i = index">
        <!-- <span class="location-title mb-2">
           {{data.ccDetails[0].locationName }}
        </span> -->

           <div class="grid mt-2 cc-widgets" >

            <div class="col">
                <div class="conn-card" style="background:#f5f8fa">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    CC Sale
                                </label>
                            </div>
                            <div>
                                <label class="widiget-figure-main">
                                    {{data.creditCardTotal | currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="conn-card" style="background:#f5f8fa">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    CC Refunds
                                </label>
                            </div>
                            <div >
                                <label class="widiget-figure-main">
                                    {{data.returnsTotal | currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col">
                <div class="conn-card" style="background:#f5f8fa">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    Tip Amount
                                </label>
                            </div>
                            <div >
                                <label class="widiget-figure-main">
                                    {{data.tipAmount | currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="col">

                <div class="conn-card" style="background:var(--brandColor);color:white">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    Expected CC Deposit
                                </label>
                            </div>
                            <div>
                                <label class="widiget-figure-main">
                                    {{ calculateSummaryTotalNoFormating("creditCardTotal", [data])-calculateSummaryTotalNoFormating("returnsTotal", [data])| currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <!-- <div class="col">
                <div class="conn-card" style="background:var(--brandColor);color:white">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                Cash Discount
                                </label>
                            </div>
                            <div >
                                <label class="widiget-figure-main">
                                    {{data.cashDiscount | currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
             <!-- <div class="col">
                <div class="conn-card" style="background:var(--brandColor);color:white">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                Fee Collected
                                </label>
                            </div>
                            <div >
                                <label class="widiget-figure-main">
                                    {{data.feesTotal | currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

  <div class="col">

                <div class="conn-card" style="background:var(--brandColor);color:white">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    Expected Gross Deposit
                                </label>
                            </div>
                            <div>
                                <label class="widiget-figure-main">
                                    {{(data.creditCardTotal-data.returnsTotal)| currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col">

                <div class="conn-card" style="background:#f5f8fa">
                    <div class="grid">
                        <div class="col-12 text-align-center">
                            <div>
                                <label class="widget-title">
                                    Expected Net Deposit : {{(data.creditCardTotal-data.returnsTotal)| currency | currencySpacing}}
                                </label>
                            </div>
                            <div>
                                <label class="widget-title" style="border-bottom: none;">
                                    Expected Gross Deposit : {{(data.creditCardTotal+data.feesTotal)-data.returnsTotal| currency | currencySpacing}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>

        <p-table [value]="data.ccDetails" dataKey="name" #dt [columns]="csvcols" styleClass="p-datatable-striped"
            [tableStyle]="{'table-layout':'fixed'}" responsiveLayout="scroll" >
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width: 16%" />
                    <col style="width: 16%" />
                    <col style="width: 18%" />
                    <col style="width: 14%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                    <col style="width: 12%" />
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="vertical-align: middle" [style.text-align]="i < 2 ? 'left' : 'right'" *ngFor="let col of domColHeader; let i = index">
                        <strong>{{col}}</strong>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded">
                <tr >
                    <td style="text-align: left; vertical-align: middle">{{ product.locationName }}</td>
                    <td style="text-align: left; vertical-align: middle">{{ product.type }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.invoiceCount }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.creditCardTotal | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.returnsTotal | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{ product.voidsTotal | currency | currencySpacing }}</td>
                    <td style="text-align: right; vertical-align: middle">{{product.feesTotal | currency | currencySpacing}}</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="rowexpansion" let-product>
                <tr>
                    <td colspan="12">
                        <div class="p-p-3">
                            <p-table [value]="product.ccDetails" dataKey="id">
                                <ng-template pTemplate="header">
                                    <tr>

                                        <th>Type</th>
                                        <th style="text-align: center">Invoice Count</th>
                                        <th style="text-align: center">CC Total ({{ '' | currencySymbol }})</th>
                                        <th style="text-align: center">Return ({{ '' | currencySymbol }})</th>
                                        <th style="text-align: center">Void ({{ '' | currencySymbol }})</th>
                                        <th style="text-align: center"># Invoice Total ({{ '' | currencySymbol }})</th>
                                        <th style="text-align: right">Fees Total ({{ '' | currencySymbol }})</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-order>
                                    <tr>
                                        <td>{{ order.type }}</td>
                                        <td style="text-align: center">{{ order.invoiceCount }}</td>
                                        <td style="text-align: center">{{ order.creditCardTotal | currency | currencySpacing }} </td>
                                        <td style="text-align: center">{{ order.returnsTotal | currency | currencySpacing }}</td>
                                        <td style="text-align: center">{{ order.voidsTotal | currency | currencySpacing }}</td>
                                        <td style="text-align: center">{{ order.invoicesTotal | currency | currencySpacing }}</td>
                                        <td style="text-align: right">{{ order.feesTotal | currency | currencySpacing }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6">
                                            There is no data to show.
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </td>
                </tr>
            </ng-template> -->
            <ng-template pTemplate="footer">
                <tr *ngIf="dataList?.length > 0">
                    <td colspan="2" style="text-align: left; vertical-align: middle"><strong>Total</strong></td>
                    <td *ngFor="let col of domSummaryflds" style="text-align: right; vertical-align: middle">{{calculateSummaryTotal(col, [data])}}</td>
                </tr>
            </ng-template>
        </p-table>
        <br *ngIf="dataList?.length !==0 " />
        <br *ngIf="dataList?.length !==0 " />
    </div>

    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>
</div>
